import { store } from '@betacrew/jars-flux'

export const componentKey = "NEW_RECIPIENT/BULK_UPLOAD";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {

        setUploadedFile: (state, action) => {
            state.uploadedFile = action.payload;
        },

        setValidationStatus: (state, action) => {
            state.validationStatus = action.payload;
        }

    },
    initialReducerState: {

        uploadedFile: null,

        validationStatus: {
            successfullyAddedPayers: "",
            payersWithErrors: 0,
            success: false,
            isTaxIdError: false
        }
    }
});

export const { setLoadingState, setUploadedFile, setValidationStatus } = actions;
